import { render, staticRenderFns } from "./PageNavigation.vue?vue&type=template&id=36bed855&scoped=true&"
import script from "./PageNavigation.vue?vue&type=script&lang=js&"
export * from "./PageNavigation.vue?vue&type=script&lang=js&"
import style0 from "./PageNavigation.vue?vue&type=style&index=0&id=36bed855&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bed855",
  null
  
)

export default component.exports